import React, { useEffect, useState, useRef } from 'react';
import styles from './index.module.scss';
import { ApiCore } from '../../api/index';
import { Player, ControlBar, ReplayControl, ForwardControl, BigPlayButton } from 'video-react';
import "video-react/dist/video-react.css";
import { Input, Button, Toast } from 'antd-mobile-v5'
import moment from 'moment';
import utils from '../../utils/utils'
import no_remark from '../../static/images_medicalLive/no_remark.png'
const api = new ApiCore();
let env = process.env.REACT_APP_ENV;

const MedicalLiveDetail = (props: any) => {
    const playerRef: any = useRef()

    const [title, setTitle] = useState('')
    const [introduction, setIntroduction] = useState('')
    const [videoImg, setVideoImg] = useState('')
    const [videoUrl, setvideoUrl] = useState('')
    const [author, setAuthor] = useState('')
    const [type, setType] = useState('')
    const [createTime, setCreateTime] = useState('')
    const [viewNum, setViewNum] = useState('')
    const [value, setValue] = useState('')
    const [remarkList, setRemarkList] = useState([])

    useEffect(() => {
        getData()
        getRemark()
        getUserInfo()
    }, [])


    const play = () => {
        playerRef.current.play()
    }

    const getData = () => {
        let id = props.match.params.id;
        
        api.getSolicitationDetail(id).then((res: any) => {
            if (res.code === 0) {
                setTitle(res.data.title)
                setIntroduction(res.data.introduction)
                setVideoImg(res.data.videoImg)
                setvideoUrl(res.data.videoUrl)
                setAuthor(res.data.author)
                setType(res.data.type)
                setCreateTime(res.data.createTime)
                setViewNum(res.data.viewNum)
                setTimeout(() => {
                    play()
                }, 500);
            }
        })
    }


    const getUserInfo = () => {
        let code = utils.getUrlParams().code || '';

        if (code) {
            let params = {
                code: code
            }
            api.getUserInfoByOfficialAccount(params).then((res: any) => {
                if (res && res.nickname) {
                    let userInfo = {
                        headimgurl: res.headimgurl,
                        nickname: res.nickname
                    }

                    window.localStorage.setItem('wxUserInfo', JSON.stringify(userInfo))
                    let remark = sessionStorage.getItem('remarkContent') || ''
                    if (remark) {
                        setValue(remark)
                        sendComment(null, remark)
                    }
                }
            })
        }
    }


    const getRemark = () => {
        let params = {
            id: props.match.params.id
        }
        api.getSolicitationRemark(params).then((res: any) => {
            if (res.code == 0) {
                setRemarkList(res.data ? res.data : [])
            }
        })
    }

    const sendComment = (e: any, content?: any) => {
        let userInfo: any = window.localStorage.getItem('wxUserInfo')
        if (userInfo) {
            userInfo = JSON.parse(userInfo)
            if (userInfo.nickname) {
                let params: any = {
                    content: content ? content : value,
                    nickName: userInfo.nickname,
                    profileImg: userInfo.headimgurl,
                    solicitationId: props.match.params.id
                }
                api.createSolicitationRemark(params).then((res: any) => {
                    if (res.code == 0) {
                        getRemark()
                        setValue('')
                        sessionStorage.removeItem('remarkContent')
                        Toast.show({
                            icon: 'success',
                            content: '评论成功',
                            duration: 1000
                        })
                    }
                })
            }
        } else {
            sessionStorage.setItem('remarkContent', value)
            let url = encodeURIComponent(window.location.href)
            let AppId = 'wx57a726c8ee3a5e62'

            if (env === 'production') {
                AppId = 'wx19684806447976d8'
            }


            let redirect_uri = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${AppId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
            window.location.replace(redirect_uri)
        }
    }


    return (
        <div className={styles.liveDetail_container}>
            <div className={styles.myplayer_content}>
                <Player
                    // autoPlay
                    poster={videoImg}
                    src={videoUrl}
                    ref={playerRef}
                >
                    <ControlBar autoHide={true}>
                        <BigPlayButton position="center" />
                        <ReplayControl seconds={5} order={2.1} />
                        <ForwardControl seconds={5} order={2.2} />
                    </ControlBar>
                </Player>
            </div>
            <div className={styles.videoContent}>
                <div className={styles.title}>{title} </div>
                <div className={styles.author}>
                    <div>{author} · {createTime ? createTime.slice(0, 10) : ''}</div>
                    <div>共{viewNum}次浏览</div>
                </div>
            </div>
            <div className={styles.infoContent}>
                <div className={styles.label}>相关信息</div>
                <div className={styles.introduction}>
                    <div>视频简介</div>
                    <div className={styles.introduction_text}>
                        {introduction}
                    </div>
                </div>
                {/* <div className={styles.videoFile}>
                    <div>视频相关文件</div>
                    <div className={styles.fileList}>
                        <div className={styles.file}>
                            <div className={styles.fileInfo}>
                                <span className={styles.fileIcon}></span>
                                <div>项目相关文件一</div>
                            </div>
                            <span className={styles.arrowIcon}></span>
                        </div>
                    </div>
                </div> */}
            </div>
            <div className={styles.infoContent}>
                <div className={styles.label}>全部评论</div>
                <div className={styles.comment_content}>
                    {
                        remarkList.map((item: any, index: number) => (
                            <div className={styles.comment_item} key={index}>
                                <img src={item.profileImg} alt="" />
                                <div className={styles.comment_item_content}>
                                    <div className={styles.userInfo}>
                                        <span className={styles.name}>{item.nickName}</span>
                                        <span className={styles.time}>{moment(item.createTime).format('YYYY-MM-DD')}</span>
                                    </div>
                                    <div className={styles.content}>{item.content}</div>
                                </div>
                            </div>
                        ))
                    }

                    {remarkList.length == 0 && <img className={styles.no_remark} src={no_remark} alt="" />}

                </div>
            </div>

            <div className={styles.comment_input_content}>
                <Input
                    placeholder='点击此处输入您的评论'
                    value={value}
                    clearable
                    onChange={val => {
                        setValue(val)
                    }}
                    maxLength={200}
                />
                <Button
                    color='primary'
                    fill='solid'
                    className={styles.submitBtn}
                    onClick={sendComment}
                    style={{ '--background-color': '#6987E5', '--border-color': '#6987E5' }}
                    disabled={value.trim() ? false : true}
                >
                    评论
                </Button>
            </div>
        </div>
    )


}

export default MedicalLiveDetail